const module = {
  state: {
    refreshList: 0,
    refreshRecord: 0,
    selectedRecord: [],
  },
  getters: {
    refreshList: (state) => state.refreshList,
    refreshRecord: (state) => state.refreshRecord,
    selectedRecord: (state) => state.selectedRecord,
  },
  mutations: {
    TRIGGER_REFRESH_LIST(state) {
      state.refreshList += 1;
    },
    TRIGGER_REFRESH_RECORD(state) {
      state.refreshRecord += 1;
    },
    SET_SELECTED_RECORD(state, record) {
      state.selectedRecord = record;
    },
    CLEAR_SELECTED_RECORD(state) {
      state.selectedRecord = null;
    },
  },
  actions: {
    triggerRefreshList({ commit }) {
      commit('TRIGGER_REFRESH_LIST');
    },
    triggerRefreshRecord({ commit }) {
      commit('TRIGGER_REFRESH_RECORD');
    },
    setSelectedRecord({ commit }, record) {
      commit('SET_SELECTED_RECORD', record);
    },
    clearSelectedRecord({ commit }) {
      commit('CLEAR_SELECTED_RECORD');
    },
  },
};

export default module;
